import React from 'react';
import Icon from '.';

const FlashIcon = props => (
	<Icon {...props} viewBox="0 0 24 24">
		<circle cx="50%" cy="50%" r="50%" />
		<path d="M0 0h24v24H0z" fill="none" />
		<g transform="scale(0.65) translate(7, 8)">
			<path fill="#FFFFFF" d="M7 2v11h3v9l7-12h-4l4-8z" />
		</g>
	</Icon>
);

export default FlashIcon;
